import { NotificationFactory } from "../NotificationFactory/NotificationFactory";
import { convertToArray, isArrayNullOrEmpty } from "../../../Utilities/Types/arrayUtilities";

const notificationFactory = new NotificationFactory();

export function clear(clearErrorWarningToastsOnly = false): void {
	return notificationFactory.clear(clearErrorWarningToastsOnly);
}

export function error(message: string): void {
	return notificationFactory.createError(message).notify();
}

export function success(message: string): void {
	return notificationFactory.createSuccess(message).notify();
}

export function info(message: string): void {
	return notificationFactory.createInfo(message).notify();
}

export function warning(message: string): void {
	return notificationFactory.createWarning(message).notify();
}

export function processNotify<T = unknown>(array: unknown, callback: (item: T) => void, clearOutNotification?: (val: T[]) => void): void {
	const items = convertToArray(array);
	if (isArrayNullOrEmpty(items)) return;

	clear();

	(items as T[]).forEach((item) => {
		callback(item);
	});

	clearOutNotification?.([]);
}
